/**
 * A condição da meta de lotes em blocos (18/10/2026, modelo do dono): título, parágrafos com o destaque em negrito,
 * as regras com o rótulo em negrito e as seções. Os blocos vêm PRONTOS do servidor (`condicaoBlocos`, de
 * `Dashboard/shared/texto-da-condicao.ts`); aqui só se montam os elementos — nada de HTML cru (§S1) nem de redigir a
 * regra de novo. Letra pequena e legível, na cor do rodapé (#52525b).
 */
import type { CSSProperties } from "react";
import type { BlocoDaCondicao } from "@/lib/api";

const COR = "#52525b";
const caixaCom = (cor: string): CSSProperties => ({ maxWidth: 820, margin: "0 auto", fontSize: 12.5, lineHeight: 1.6, color: cor });
const tituloCom = (cor: string): CSSProperties => ({ fontSize: 14, fontWeight: 700, margin: "0 0 8px", color: cor });
const subtituloCom = (cor: string): CSSProperties => ({ fontSize: 12.5, fontWeight: 700, margin: "14px 0 4px", color: cor });
const paragrafo: CSSProperties = { margin: "0 0 8px" };
const lista: CSSProperties = { margin: "0 0 8px", paddingLeft: 18, listStyle: "disc" };

/** `cor`: no rodapé preto do site vai clara (#a1a1aa); fora dele, a padrão (#52525b). */
export function CondicaoEmBlocos({ blocos, marca, cor = COR }: { blocos: readonly BlocoDaCondicao[]; marca?: string; cor?: string }) {
  const caixa = caixaCom(cor), titulo = tituloCom(cor), subtitulo = subtituloCom(cor);
  return (
    <div style={caixa} data-testid="condicao-em-blocos">
      {blocos.map((b, i) => {
        if (b.tipo === "titulo") return <h3 key={i} style={titulo}>{marca ? `${marca} ` : null}{b.texto}</h3>;
        if (b.tipo === "subtitulo") return <h4 key={i} style={subtitulo}>{b.texto}</h4>;
        if (b.tipo === "paragrafo") {
          return <p key={i} style={paragrafo}>{b.trechos.map((t, j) => (t.negrito ? <strong key={j}>{t.texto}</strong> : <span key={j}>{t.texto}</span>))}</p>;
        }
        return <ul key={i} style={lista}>{b.itens.map((it, j) => <li key={j}><strong>{it.rotulo}</strong> {it.texto}</li>)}</ul>;
      })}
    </div>
  );
}
